module.exports = __webpack_public_path__ + "static/media/logo.99f047f1.png";